// Global promise to track loading state across multiple calls
let loadingPromise: Promise<void> | null = null;

export default defineNuxtPlugin(() => {
  return {
    provide: {
      loadGoogleMaps: () => {
        // Return existing loading promise if already loading
        if (loadingPromise) {
          return loadingPromise;
        }

        loadingPromise = new Promise<void>((resolve, reject) => {
          if (typeof window === 'undefined') {
            reject(new Error('Window is not defined'));
            return;
          }

          // Check if Google Maps is already loaded
          if ((window as any).google?.maps) {
            resolve();
            return;
          }

          // Check if script tag already exists
          const existingScript = document.querySelector(
            'script[src*="maps.googleapis.com"]'
          );
          if (existingScript) {
            // Script tag exists, wait for it to load
            existingScript.addEventListener('load', () => resolve());
            existingScript.addEventListener('error', (e) => reject(e));
            return;
          }

          // Create new script tag
          const script = document.createElement('script');
          script.src = `https://maps.googleapis.com/maps/api/js?key=${
            useRuntimeConfig().public.googleApiKey
          }&libraries=places`;
          script.async = true;
          script.defer = true;
          script.onload = () => resolve();
          script.onerror = (e) => reject(e);
          document.head.appendChild(script);
        });

        return loadingPromise;
      }
    }
  };
});
